module.exports = __webpack_public_path__ + "img/company-documents.92ab8e59.svg";